import { render, staticRenderFns } from "./UpdateAppDialog.vue?vue&type=template&id=722bd681&scoped=true&"
import script from "./UpdateAppDialog.vue?vue&type=script&lang=js&"
export * from "./UpdateAppDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAppDialog.vue?vue&type=style&index=0&id=722bd681&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722bd681",
  null
  
)

export default component.exports